var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.submit()},"mouseenter":_vm.toggleStitchHover,"mouseleave":_vm.toggleStitchHover}},[_c('HeartIcon',{staticClass:"heart-icon float-right",attrs:{"width":"26px","height":"26px","hovering":_vm.stitchHovering,"stitched":_vm.currentUserStitchedOutfit}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f0ef74","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/showCapsule/StitchButton.vue
// module id = 54uG
// module chunks = 0